import storage from './storage'
const user = {
  name: '_xn_a',
  pwd: '_xn_p',
  tel: '_xn_t',
  info: '_xn_if'
}
const mdl = {
  clue: '_xn_clu',
  interview: '_xn_itv',
  topic: '_xn_tpc'
}

export default {
  // 存储登录信息：用户名
  setUserName(n) {
    storage.localStorage.setItem(user.name, n)
  },
  getUserName() {
    const name = storage.localStorage.getItem(user.name)

    return name || ''
  },
  delUserName() {
    storage.localStorage.removeItem(user.name)
  },
  setUserPwd(p) {
    // 存储登录信息：密码
    storage.localStorage.setItem(user.pwd, p)
  },
  getUserPwd() {
    const pwd = storage.localStorage.getItem(user.pwd)

    return pwd || ''
  },
  delUserPwd() {
    storage.localStorage.removeItem(user.pwd)
  },
  setUserTel(t) {
    // 存储登录信息：手机号
    storage.localStorage.setItem(user.tel, t)
  },
  getUserTel() {
    const tel = storage.localStorage.getItem(user.tel)

    return tel || ''
  },
  delUserTel() {
    storage.localStorage.removeItem(user.tel)
  },
  setClue(c) {
    // 存储线索信息
    storage.sessionStorage.setItem(mdl.clue, JSON.stringify(c))
  },
  getClue() {
    const c = storage.sessionStorage.getItem(mdl.clue)

    return JSON.parse(c) || ''
  },
  delClue() {
    storage.sessionStorage.removeItem(mdl.clue)
  },
  setItv(i) {
    // 存储线索信息
    storage.sessionStorage.setItem(mdl.interview, JSON.stringify(i))
  },
  getItv() {
    const i = storage.sessionStorage.getItem(mdl.interview)

    return JSON.parse(i) || ''
  },
  delItv() {
    storage.sessionStorage.removeItem(mdl.interview)
  },
  setUsrInfo(usr) {
    storage.sessionStorage.setItem(user.info, JSON.stringify(usr))
  },
  getUsrInfo() {
    const info =  storage.sessionStorage.getItem(user.info)

    return JSON.parse(info) || ''
  },
  delUsrInfo() {
    storage.sessionStorage.removeItem(user.info)
  },
  setTpc(t) {
    // 存储策划信息
    storage.sessionStorage.setItem(mdl.topic, JSON.stringify(t))
  },
  getTpc() {
    const t = storage.sessionStorage.getItem(mdl.topic)

    return JSON.parse(t) || ''
  },
  delTpc() {
    storage.sessionStorage.removeItem(mdl.topic)
  }
}
